export enum AppointmentMode {
  Standard,
  NonRefundable,
  ReservedSchedule,
}
